import { render, staticRenderFns } from "./FooterStyle3.vue?vue&type=template&id=069dc5bb"
import script from "./FooterStyle3.vue?vue&type=script&lang=js"
export * from "./FooterStyle3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports